 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHTPAGE from '@/components/copyrightpage'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import CONTENTS from '@/components/Contents'
 import WHY_RULE_OF_THUMB from '@/components/Why_Rule_of_Thumb'
 import INTRODUCTION from '@/components/Introduction'
 import CHAPTER01 from '@/components/chapter01'
 import CHAPTER02 from '@/components/chapter02'
 import FRONTMATTER05 from '@/components/frontmatter05'
 import FRONTMATTER06 from '@/components/frontmatter06'
 import FRONTMATTER07 from '@/components/frontmatter07'
 import FRONTMATTER08 from '@/components/frontmatter08'
 import FRONTMATTER09 from '@/components/frontmatter09'
 import FRONTMATTER10 from '@/components/frontmatter10'
 import FRONTMATTER11 from '@/components/frontmatter11'
 import FRONTMATTER12 from '@/components/frontmatter12'
 import FRONTMATTER13 from '@/components/frontmatter13'
 import FRONTMATTER14 from '@/components/frontmatter14'
 import CHAPTER03 from '@/components/chapter03'
 import CHAPTER04 from '@/components/chapter04'
 import CHAPTER05 from '@/components/chapter05'
 import CHAPTER06 from '@/components/chapter06'
 import CHAPTER07 from '@/components/chapter07'
 import CHAPTER08 from '@/components/chapter08'
 import CHAPTER09 from '@/components/chapter09'
 import AFTERWORD from '@/components/Afterword'
 import SUGGESTED_RESOURCES from '@/components/Suggested_resources'
 import REFERENCES from '@/components/References'
 import ABOUT_THE_AUTHOR from '@/components/About_the_author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/copyrightpage",
 			"name" : "copyrightpage",
 			"component" : COPYRIGHTPAGE
 		},
 		{
 			"path" : "/Acknowledgments",
 			"name" : "Acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Why_Rule_of_Thumb",
 			"name" : "Why_Rule_of_Thumb",
 			"component" : WHY_RULE_OF_THUMB
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/chapter01",
 			"name" : "chapter01",
 			"component" : CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js